// eslint-disable-next-line import/prefer-default-export
export const TOOLTIP_DEFAULT_OPTIONS = {
  html: true,
  container: 'body',
  placement: 'top',
  triggers: ['hover', 'focus'],
  themes: {
    tooltip: {
      $extend: 'tooltip',
    },
  },
};
